import React from "react";

import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";

// Material Dashboard 2 PRO React base styles
import typography from "../assets/theme/base/typography";
import MDTypography from "../components/MDTypography";
import MDBox from '../components/MDBox';

export default function OthelloFooter({ ...props }) {
    const {  } = props;

    const { size } = typography;


    var linkcookies = "/condiciones/info?tipo=C";
    var linkuso = "/condiciones/info?tipo=U";
    var linkcancelacion = "/condiciones/info?tipo=D";
    var linkprivacidad = "/condiciones/info?tipo=P";

    let links = [];

    /*var webtexto = "";

    if (modoVisualizacion == ModoVisualizacionesPay.Tienda)
        webtexto = "Establecimiento";
    else if (modoVisualizacion == ModoVisualizacionesPay.Hotel)
        webtexto = "Hotel";*/

    //links.push({ href: linkhotel, name: webtexto });
    links.push({ href: linkcancelacion, name: "Pol\u00EDtica de Cancelaci\u00F3n" });
    links.push({ href: linkuso, name: "Condiciones de Uso" });
    links.push({ href: linkcookies, name: "Pol\u00EDtica Cookies" });
    links.push({ href: linkprivacidad, name: "Pol\u00EDtica de Privacidad" });
    
    const renderLinks = () =>
        links.map((link) => (
            <MDBox key={link.name} component="li" px={2} lineHeight={1} pb={2}>
                <Link href={link.href} target="_blank">
                    <MDTypography variant="button" fontWeight="regular" color="text" fontSize={size.sm}>
                        {link.name}
                    </MDTypography>
                </Link>
            </MDBox>
        ));

    return (
        <MDBox
            width="100%"
            display="flex"
            flexDirection={{ xs: "column", lg: "row" }}
            justifyContent="center"
            alignItems="center"
            px={1.5}
            pb={3}
        >
            <MDBox
                component="ul"
                sx={({ breakpoints }) => ({
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "center",
                    listStyle: "none",
                    mt: 3,
                    mb: 0,
                    p: 0,

                    [breakpoints.up("lg")]: {
                        mt: 0,
                    },
                })}
            >
                {renderLinks()}
            </MDBox>
        </MDBox>
    );
}